export const spacing = {
  small: 10,
  medium: 20,
  large: 30,
};
